// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"0e2a74eb","96":"8728d1c1","233":"936bf33e","453":"9444281c","469":"02cd03c5","532":"f107fd79","731":"dbd0cd26"}[chunkId] + ".chunk.js";
};